<template lang="pug">
  #Carrito
    Header
    div(style='background-color: gainsboro;height: 60px;display: flex;justify-content: center;align-items: center;')
      v-flex(xs11)
        v-layout(wrap)  
          v-flex(xs12 style='display: flex;justify-content: flex-start;align-items: center;')
            a(style='font:size:14px;font-weight: bold;color: #c70000;text-decoration: initial;' href='/') Inicio
            span(style='padding-left:10px;') /
            span(style='font:size:14px;padding-left:10px;font-weight: bold;') Historial de pedidos
    div
      v-layout(wrap style='display:flex;justify-content:center;margin-top:70px;')
        v-flex(xs10 style='display:flex;justify-content:center;background-color: rgb(135, 135, 135);height: 55px;align-items: center;')
          v-layout(wrap v-if='ordenes.length > 0')
            v-flex(xs12 sm6)#serch
              v-text-field(outlined dense v-model='search' placeholder='Buscar...' style='padding:10px;' color='white' @keyup.enter='initialize()')
            v-flex(xs12 sm6 style='text-align: center;display: flex;justify-content: center;align-items: center;')
              span(style='color:white;') Mostrando pedidos 1 - {{ordenes.length}} de {{totalO}} resultados
        v-flex(xs10 style='display:flex;justify-content:center;height: 55px;align-items: center;margin-top: 10px;' v-if='pantalla >= 820')
          v-layout(wrap style='border-bottom: 1px solid #e4e7ea;padding-bottom: 5px;')
            v-flex(xs2).hed
              span CODIGO
            v-flex(xs3).hed
              span FECHA
            v-flex(xs2).hed
              span MONTO
            v-flex(xs3).hed
              span ESTATUS
            v-flex(xs2).hed
              span ACCIÓN
        v-flex(xs10 style='display:flex;justify-content:center;height: auto;align-items: center;' v-for='item in ordenes')
          v-layout(wrap style='border-bottom: 1px solid #e4e7ea;padding-bottom: 12px;margin-top: 20px;position:relative;' v-if='pantalla < 820')
            v-flex(xs10 style='display: flex;align-items: center;')
              div(style='display: flex;flex-direction: column;padding: 8px;text-align: start;')
                span(style='font-size: 15px;font-weight: 500;') Orden nro: {{item.doc_num}}
                span(style='font-size: 15px;font-weight: 500;') Fecha: {{item.fec_emis | moment("DD-MM-YYYY, h:mm a")}}
                span(style='font-size: 15px;font-weight: 500;opacity: 0.8;') Total: ${{item.total_neto}}
                span(style='font-size: 15px;font-weight: 500;opacity: 0.8;') Estatus: {{compararE(item.status)}}
            v-flex(xs2).centrar
              v-icon(style='cursor: pointer;' @click='editItem(item)') visibility
          v-layout(wrap style='border-bottom: 1px solid #e4e7ea;padding-bottom: 12px;margin-bottom: 20px;' v-if='pantalla >= 820')
            v-flex(xs2).centrar
              span(style='opacity: 0.7;') {{item.doc_num}}
            v-flex(xs3).centrar
              span(style='opacity: 0.7;') {{item.fec_emis | moment("DD-MM-YYYY, h:mm a")}}
            v-flex(xs2).centrar
              span(style='opacity: 0.7;') ${{item.total_neto}}
            v-flex(xs3).centrar
              span(style='opacity: 0.7;') {{compararE(item.status)}}
            v-flex(xs2).centrar
              v-tooltip(bottom)
                template(v-slot:activator='{ on }')
                  v-icon.mr-2(@click='editItem(item)' v-on="on") visibility
                | Ver orden
        v-flex(xs10 style='display:flex;justify-content:center;height: auto;align-items: center;margin-bottom:20px;')
          v-progress-circular(v-if='loading' indeterminate='', color='#c7c7c7')
          v-btn(v-if='!loading && ordenes.length !== totalO' style='color:white;background:#c70000;border-radius:0px;' @click='verM()').elevation-0 ver más
    v-dialog(v-model='dialog', persistent max-width='900px')
      v-container(style='background-color:white !important;max-width: 900px;padding:30px;height: 100%;')
        v-flex(xs12)
          template
            v-card(flat='')
              v-flex(xs12 md12 sm12)
                v-layout(row, wrap)
                  v-flex(xs12 style='display: flex;justify-content: center;margin-bottom:20px;')
                    div(style='display: flex;align-items: center;')
                      img(src='../assets/imgFerco/logo2.png', style='width: auto;height: 50px;margin-top: 0px;margin-bottom: 0px;object-fit: contain;')
                  v-flex(xs12 style='padding-top: 20px;background: rgb(135, 135, 135);height: 100%;display: flex;align-items: flex-end;')
                    v-layout(wrap style='line-height: 1;')
                      v-flex(xs6)
                        div(style='padding-left: 15px;')
                          p(style='font-weight: 500;').white--text Orden: {{form.doc_num}}
                          p(style='font-weight: 500;').white--text Fecha: {{form.fec_emis | moment("DD-MM-YYYY, h:mm a")}}
                          p(style='font-weight: 500;').white--text Vendedor: {{form.vendedor}}
                      v-flex(xs6 style='display: flex;justify-content: center;align-items: center;flex-direction: column;')
                        p(style='font-size: 21px !important;font-weight: 600;').white--text {{compararE(form.status)}}
                  v-flex(xs12 style='height: 45px;background: transparent;display: flex;align-items: center;border-bottom: 1px solid;')
                    v-layout(wrap style='line-height: 1;')
                      v-flex(xs6 style='padding-left: 15px;')
                        span(style='font-weight: 500;') Producto
                      v-flex(xs3)
                        span(style='font-weight: 500;display: flex;justify-content: center;') Cantidad
                      v-flex(xs3)
                        span(style='font-weight: 500;display: flex;justify-content: center;') Monto
                  v-flex(v-for='(item,index) in form.renglones' xs12 v-bind:class="{ 'active': par(index), 'pasive': comparar(index) }" style='height: auto;padding: 10px;background: rgb(250, 250, 250);display: flex;align-items: center;')
                    v-layout(wrap style='line-height: 1;')
                      v-flex(xs6 style='padding-left: 15px;')
                        span(style='font-weight: 400;font-size: 14px;') {{item.articulo.art_des}}
                      v-flex(xs3 style='display: flex;justify-content: center;align-items: center;')
                        span(style='font-weight: 400;display: flex;justify-content: center;font-size: 14px;') {{item.total_art}}
                      v-flex(xs3 style='display: flex;justify-content: center;align-items: center;')
                        span(style='font-weight: 400;display: flex;justify-content: center;font-size: 14px;') ${{item.reng_neto}}
                  v-flex(xs12 style='height: 45px;background: #fff;display: flex;align-items: center;')
                  v-flex(xs12 style='height: 45px;background: rgb(250, 250, 250);display: flex;align-items: center;')
                    v-layout(wrap style='line-height: 1;')
                      v-flex(xs6)
                      v-flex(xs3 style='display: flex;justify-content: center;')
                        span(style='font-weight: 500;') Total:
                      v-flex(xs3 style='display: flex;justify-content: center;')
                        span(style='font-weight: 400 !important;font-style: italic;') ${{form.total_neto}}
              v-flex(xs12 sm12 style='margin-top:20px')
                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                  v-btn(style="background:#c70000;border-radius:0px;color:white;", @click.native='close').elevation-0 Salir
    //===========================================================Modal Espera==============================================================================================
    v-dialog(v-model='loading2', persistent max-width='400px' style='background:#f1f2f1')
      v-container(style='max-width: 400px;background:#f1f2f1')
        div(style="margin-top: 20px;")
            v-flex(xs12 sm12)
              v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                v-flex(xs12)
                  v-card-title(style="padding: 7px;").justify-center
                    h4.black--text  Esperando Respuesta del Servidor.!!
                v-flex(xs12)
                    div(style='display: flex;justify-content: center;').text-xs-center
                      img(src='../assets/waiting.gif', with='200' ,height='150')
                v-flex(xs12)
                  v-card-title(style="padding: 7px;").justify-center
                    h5.black--text  Por favor espere...
    Footer
</template>

<script>
import Footer from '@/components/Footer.vue'
import Header from '@/components/Header.vue'
import Api from '@/services/methods'
import Swal from 'sweetalert2/dist/sweetalert2.min.js'
import { mapState, mapActions } from 'vuex'
import { server, port } from "@/services/environment"
export default {
  name: 'Historial',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      search: "",
      loading2: false,
      loading: false,
      skip: 0,
      form: {
        cliente: "",
        doc_num: "",
        fec_emis: "",
        renglones: [],
        status: "",
        total_neto: 0,
        vendedor: ""
      },
      totalO: "",
      dialog: false,
      defaultForm: {
        cliente: "",
        doc_num: "",
        fec_emis: "",
        renglones: [],
        status: "",
        total_neto: 0,
        vendedor: ""
      },
      pantalla: screen.width,
      ruta: server + ':' + port,
      ordenes: []
    }
  },
  created () {
    this.initialize()
    document.documentElement.scrollTop = 0
  },
  methods: {
    compararE(data) {
      if (data === "0") {
        return "Creado"
      }
      if (data === "1") {
        return "Pendiente"
      }
      if (data === "2") {
        return "Procesado"
      }
    },
    comparar(data) {
      if ((data+1) === this.form.renglones.length) {
        return true;
      } else {
        return false;
      }
    },
    par(data) {
      if (data % 2 === 0) {
        return false;
      } else {
        return true;
      }
    },
    editItem(item) {
      this.loading2 = true
      Api.get('pedidosCom/cod/' + item.doc_num).then(res=> {
        let info = res.data[0]
        if (info) {
          Object.keys(this.form).map(key => {
            if (info[key]) this.form[key] = info[key];
          });
          this.form._id = info._id;
          setTimeout(function() {
            this.loading2 = false
            this.dialog = true
          }.bind(this), 1000);
        } else {
          this.loading2 = false
          Swal.fire(
            'Error inesperado',
            'Problemas de conexión, por favor inténtelo nuevamente.',
            'error'
          )
        }
      }).catch(err =>{
        setTimeout(function() {
          this.loading2 = false
          console.log(err)
          Swal.fire(
            'Error inesperado',
            'Problemas de conexión, por favor inténtelo nuevamente.',
            'error'
          )
        }.bind(this), 1000);
      })
    },
    close() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog = false;
      // this.initialize();
    },
    verM() {
      this.loading = true
      Api.get('pedidosCom/cli/' + this.$store.state.emanuelWeb.co_cli + '?skip='+ this.skip + '&busqueda=' + this.search).then(res=> {
        for (let i = 0; i < res.data.length; i++) {
          this.ordenes.push(res.data[i])
        }
        this.loading = false
        this.skip += 10
      }).catch(err=>{
        this.loading = false
        console.log(err)
        Swal.fire(
          'Error inesperado',
          'Problemas de conexión, por favor inténtelo nuevamente.',
          'error'
        )
      })
    },
    initialize() {
      if (this.$store.state.emanuelWeb.co_cli) {
        this.skip = 0
        this.loading = true
        Api.get('pedidosCom/cli/' + this.$store.state.emanuelWeb.co_cli + '?skip='+ this.skip + '&busqueda=' + this.search).then(res=> {
          this.ordenes = res.data
          this.skip += 10
          this.loading = false
        }).catch(err=>{
          this.loading = false
          console.log(err)
        })
        Api.get('pedidosCom/cliCont/' + this.$store.state.emanuelWeb.co_cli + '?busqueda='+ this.search).then(res=> {
          this.totalO = res.data
        })
      }
    }
  },
}
</script>
<style lang="scss">
.active {
  background: #fff !important;
}
.pasive {
  border-bottom: 1px solid !important;
}
@import "~@/assets/scss/carrito.scss";
</style>
